import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const AccountExistsModal = ({ visible, onEditEmail }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('checkout.accountExists')}
      className="model-title"
      visible={visible}
      onOk={onEditEmail}
      onCancel={onEditEmail}
      footer={null}
    >
      <div className="modal-body">
        {t('checkout.accountExistsMsg')}{' '}
        <a
          href="https://www.earthlink.net/about-us/contact/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#007dba' }}
        >
          {' '}
          {t('checkout.support')}
        </a>
        . {t('checkout.orEnterDifferentEmail')}
      </div>

      <div style={{ textAlign: 'right', marginTop: 24 }}>
        <button onClick={onEditEmail} className="ant-btn ant-btn-primary">
          {t('common.ok')}
        </button>
      </div>
    </Modal>
  );
};

export default AccountExistsModal;
